import Vue from 'vue'
export default {
  state: {
    optionLegs: [],
    optionChainStrikes: [],
    optionLegStrikeList: [],
    equityLeg: [],
    distinctCallPut: null,
    strategy: null,
  },
  getters: {
    getoptionChainStrikes: (state) => state.optionChainStrikes,
    getoptionLegs: (state) => state.optionLegs,
    getequityLeg: (state) => state.equityLeg,
    getdistinctCallPut: (state) => state.distinctCallPut,
    getstrategy: (state) => state.strategy,
    getOptionLegStrikeList: (state) => state.optionLegStrikeList,
  },
  mutations: {
    setoptionChainStrikes: (state, payload) => {
      state.optionChainStrikes = [
        ...new Set([...state.optionChainStrikes, ...payload]),
      ]
      state.optionChainStrikes = state.optionChainStrikes.sort((a, b) => a - b)
    },
    setOptionLegStrikeList: (state, val) => {
      Vue.set(state.optionLegStrikeList, val.index, val.value)
    },
    setoptionLegAction: (state, val) => {
      state.optionLegs[val.index].action = val.value
    },
    setEquityAction: (state, val) => {
      state.equityLeg[0].action = val
    },
    setEquityQuantity: (state, val) => {
      state.equityLeg[0].quantity = val
    },
    setoptionLegQuantity: (state, val) => {
      state.optionLegs[val.index].quantity = val.value
    },
    setoptionLegSymbol: (state, val) => {
      state.optionLegs[val.index].occSymbol = val.value
    },
    setoptionLegExpiration: (state, val) => {
      state.optionLegs[val.index].expiration = val.value
    },
    setoptionLegStrike: (state, val) => {
      state.optionLegs[val.index].strike = val.value
    },
    setoptionLegType: (state, val) => {
      state.optionLegs[val.index].type = val.value
    },
    setoptionLegSharesPerContract: (state, val) => {
      state.optionLegs[val.index].sharesPerContract = val.value
    },
    addLeg: (state, val) => {
      if (state.optionLegs.length == 4) {
        Vue.notify({
          type: 'error',
          title: 'Error',
          text: 'Maximum of 4 legs can be added',
          duration: 3000,
        })
        return
      } else if (state.optionLegs.length == 3 && state.equityLeg.length == 1) {
        Vue.notify({
          type: 'error',
          title: 'Error',
          text: 'Maximum of 4 legs can be added',
          duration: 3000,
        })
        return
      }
      state.optionLegs.push(val)
    },
    removeLeg: (state, val) => {
      state.optionLegs.splice(val, 1)
    },
    setoptionLegs: (state, val) => {
      // state.equityLeg = []
      state.optionLegs = []
      val.forEach((item) => {
        // if (item.legType == 'EQUITY') {
        //     state.equityLeg.push(item)
        // }
        // else {
        state.optionLegs.push(item)
        // }
      })
      // if (val.type == 2315 || [val.index].type == 2314) {
      // }
    },
    setequityLeg: (state, val) => {
      state.equityLeg = []
      // state.optionLegs = []
      // let leg = { action: Actions.Buy, quantity: 1, bid: state.stockQuote.bid, ask: state.stockQuote.ask, mid: state.stockQuote.mid, type: "EQUITY" }
      // if (leg.type == 'EQUITY' || val.type == 'EQUITY') {
      state.equityLeg.push(val)
      // }
    },
    removeEquityLeg: (state) => {
      state.equityLeg = []
    },
    setLegQuote: (state, val) => {
      if (val?.expiration === state.optionLegs[val.index].expiration) {
        state.optionLegs[val.index].bid = val.bid.toFixed(2)
        state.optionLegs[val.index].ask = val.ask.toFixed(2)
        state.optionLegs[val.index].mid = ((val.bid + val.ask) / 2).toFixed(2)
      }
    },
    setEquityLegQuote: (state, val) => {
      if (state.equityLeg[0]) {
        state.equityLeg[0].bid = val.bid
        state.equityLeg[0].ask = val.ask
        state.equityLeg[0].mid = (
          (parseFloat(val.bid) + parseFloat(val.ask)) /
          2
        ).toFixed(2)
      }
    },
    setdistinctCallPut: (state, val) => {
      state.distinctCallPut = val
    },
    swapActionContent: (state) => {
      var items = state.optionLegs
      items.forEach((leg) => {
        if (leg.action == 276) {
          leg.action = 277
        } else if (leg.action == 277) {
          leg.action = 276
        } else if (leg.action == 278) {
          leg.action = 275
        } else if (leg.action == 275) {
          leg.action = 278
        }
      })
    },
    swapTypeContent: (state) => {
      var items = state.optionLegs
      items.forEach((leg) => {
        if (leg.type == 2315) {
          leg.type = 2314
        } else {
          leg.type = 2315
        }
      })
    },
    nextStrike: (state) => {
      var items = state.optionLegs
      items.forEach((leg, i) => {
        var list = state.optionLegStrikeList[i].sort((a, b) => a - b)
        var index = list.indexOf(leg.strike)
        leg.strike = list[index + 1]
      })
    },
    // nextStrike: (state, val) => {
    //     var items = state.optionLegs;
    //     items.forEach((leg) => {
    //         var index = val.indexOf(leg.strike)
    //         leg.strike = val[index + 1]
    //     })
    // },
    previousStrike: (state) => {
      var items = state.optionLegs
      items.forEach((leg, i) => {
        var list = state.optionLegStrikeList[i].sort((a, b) => a - b)
        var index = list.indexOf(leg.strike)
        leg.strike = list[index - 1]
      })
    },
    // previousStrike: (state, val) => {
    //     var items = state.optionLegs;
    //     items.forEach((leg) => {
    //         var index = val.indexOf(leg.strike)
    //         leg.strike = val[index - 1]
    //     })
    // },
    nextExpiration: (state, val) => {
      var items = state.optionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.expiration)
        leg.expiration = val[index + 1]
      })
    },
    previousExpiration: (state, val) => {
      var items = state.optionLegs
      items.forEach((leg) => {
        var index = val.indexOf(leg.expiration)
        leg.expiration = val[index - 1]
      })
    },
    addQuantityContent: (state, val) => {
      var items = state.optionLegs
      var i = 0
      items.forEach((leg) => {
        i += 1
        var array = val.split('x')
        leg.quantity = parseInt(leg.quantity) + parseInt(array[i - 1])
        if (leg.quantity < 0) {
          leg.quantity = 0
        }
      })
      if (state.equityLeg.length > 0) {
        state.equityLeg[0].quantity =
          state.optionLegs[0].sharesPerContract * state.optionLegs[0].quantity
      }
    },
    minusQuantityContent: (state, val) => {
      var items = state.optionLegs
      var i = 0
      items.forEach((leg) => {
        i += 1
        var array = val.split('x')
        leg.quantity = parseInt(leg.quantity) - parseInt(array[i - 1])
        if (leg.quantity < 0) {
          leg.quantity = 0
        }
      })
      if (state.equityLeg.length > 0) {
        state.equityLeg[0].quantity =
          state.optionLegs[0].sharesPerContract * state.optionLegs[0].quantity
      }
    },
    setCashSecured: (state, val) => {
      if (state.optionLegs.length == 1) {
        // state.optionLegs[0].push({cashSecured: true, cashSecuredAmount: parseFloat(state.optionLegs[0].strike) * parseInt(state.optionLegs[0].sharesPerContract)})
        state.optionLegs[0].cashSecured = true
        console.log(
          'setting',
          parseFloat(state.optionLegs[0].strike) *
            parseInt(state.optionLegs[0].sharesPerContract)
        )
        state.optionLegs[0].cashSecuredAmount =
          parseFloat(state.optionLegs[0].strike) *
          parseInt(state.optionLegs[0].sharesPerContract)
      }
    },
    removeCashSecured: (state, val) => {
      if (state.optionLegs[0]) {
        state.optionLegs[0].cashSecured = false
        state.optionLegs[0].cashSecuredAmount = '0.00'
      }
    },
    setStrategy: (state) => {
      if (state.equityLeg.length == 0) {
        if (state.optionLegs.length != 0) {
          if (state.optionLegs.length == 1) {
            if (state.optionLegs[0].type == 2315) {
              if (state.optionLegs[0].action == 276) {
                state.strategy = 'LONG_CALL'
              } else if (state.optionLegs[0].action == 277) {
                state.strategy = 'SHORT_CALL'
              } else {
                //error
                state.strategy = 'CUSTOM'
                console.log('error single leg')
              }
            } else {
              if (state.optionLegs[0].action == 276) {
                state.strategy = 'LONG_PUT'
              } else if (state.optionLegs[0].action == 277) {
                if (state.optionLegs[0].cashSecured) {
                  state.strategy = 'CASH_SECURED_PUT'
                } else {
                  state.strategy = 'SHORT_PUT'
                }
              } else {
                //error
                state.strategy = 'CUSTOM'
              }
            }
          }
          if (state.optionLegs.length == 2) {
            if (state.optionLegs[0].type == state.optionLegs[1].type) {
              if (
                state.optionLegs[0].expiration == state.optionLegs[1].expiration
              ) {
                // if (state.optionLegs[0].strike < state.optionLegs[1].strike) {
                if (
                  state.optionLegs[0].quantity == state.optionLegs[1].quantity
                ) {
                  if (
                    state.optionLegs[0].action == 276 &&
                    state.optionLegs[1].action == 277
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'LONG_CALL_SPREAD'
                    } else {
                      state.strategy = 'SHORT_PUT_SPREAD'
                    }
                  } else if (
                    state.optionLegs[0].action == 277 &&
                    state.optionLegs[1].action == 276
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'SHORT_CALL_SPREAD'
                    } else {
                      state.strategy = 'LONG_PUT_SPREAD'
                    }
                  } else {
                    // THROW AN ERROR
                    state.strategy = 'ERROR'
                  }
                  // }
                } else {
                  state.strategy = 'CUSTOM'
                }
              } else if (
                state.optionLegs[0].strike == state.optionLegs[1].strike
              ) {
                // calendar
                var date0Updated = new Date(
                  state.optionLegs[0].expiration.replace(/-/g, '/')
                )
                var date1Updated = new Date(
                  state.optionLegs[1].expiration.replace(/-/g, '/')
                )
                if (date0Updated < date1Updated) {
                  if (
                    state.optionLegs[0].action == 277 &&
                    state.optionLegs[1].action == 276
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'LONG_CALL_CALENDAR'
                    } else {
                      state.strategy = 'LONG_PUT_CALENDAR'
                    }
                  } else if (
                    state.optionLegs[0].action == 276 &&
                    state.optionLegs[1].action == 277
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'SHORT_CALL_CALENDAR'
                    } else {
                      state.strategy = 'SHORT_PUT_CALENDAR'
                    }
                  }
                }
                //this section below causes problems due to the sorting of strikes and expirations but works without it
                // else {
                //     if (state.optionLegs[0].action == 276 && state.optionLegs[1].action == 277) {
                //         if (state.optionLegs[0].type == 2315) {
                //             state.strategy = "SHORT_CALL_CALENDAR"
                //         }
                //         else {
                //             state.strategy = "SHORT_PUT_CALENDAR"
                //         }
                //     }
                //     else if (state.optionLegs[0].action == 277 && state.optionLegs[1].action == 276) {
                //         if (state.optionLegs[0].type == 2315) {
                //             state.strategy = "LONG_CALL_CALENDAR"
                //         }
                //         else {
                //             state.strategy = "LONG_PUT_CALENDAR"
                //         }
                //     }
                //     else {
                //         // THROW AN ERROR
                //         state.strategy = "CUSTOM"
                //     }
                // }
              } else {
                // "diagonal"
                var date0Diagonal = new Date(
                  state.optionLegs[0].expiration.replace(/-/g, '/')
                )
                var date1Diagonal = new Date(
                  state.optionLegs[1].expiration.replace(/-/g, '/')
                )
                if (date0Diagonal > date1Diagonal) {
                  if (
                    state.optionLegs[0].action == 276 &&
                    state.optionLegs[1].action == 277
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'LONG_CALL_DIAGONAL'
                    } else {
                      state.strategy = 'LONG_PUT_DIAGONAL'
                    }
                  } else if (
                    state.optionLegs[0].action == 277 &&
                    state.optionLegs[1].action == 276
                  ) {
                    if (state.optionLegs[0].type == 2315) {
                      state.strategy = 'SHORT_CALL_DIAGONAL'
                    } else {
                      state.strategy = 'SHORT_PUT_DIAGONAL'
                    }
                  } else {
                    // THROW AN ERROR
                    state.strategy = 'CUSTOM'
                  }
                }
                // else {
                //     if (state.optionLegs[0].action == 276 && state.optionLegs[1].action == 277) {
                //         if (state.optionLegs[0].type == 2315) {
                //             state.strategy = "SHORT_CALL_DIAGONAL"
                //         }
                //         else {
                //             state.strategy = "SHORT_PUT_DIAGONAL"
                //         }
                //     }
                //     else if (state.optionLegs[0].action == 277 && state.optionLegs[1].action == 276) {
                //         if (state.optionLegs[0].type == 2315) {
                //             state.strategy = "LONG_CALL_DIAGONAL"
                //         }
                //         else {
                //             state.strategy = "LONG_PUT_DIAGONAL"
                //         }
                //     }
                //     else {
                //         // THROW AN ERROR
                //         state.strategy = "CUSTOM"
                //     }
                // }
              }
            } else {
              if (
                state.optionLegs[0].expiration == state.optionLegs[1].expiration
              ) {
                if (state.optionLegs[0].strike == state.optionLegs[1].strike) {
                  if (state.optionLegs[0].type == 2315) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_STRADDLE'
                    }
                    if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_STRADDLE'
                    }
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SYNTHETIC_LONG'
                    }
                    if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'SYNTHETIC_SHORT'
                    }
                    // else {
                    //     //throw an error
                    //     state.strategy = "CUSTOM"
                    // }
                  } else {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_STRADDLE'
                    }
                    if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_STRADDLE'
                    }
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SYNTHETIC_SHORT'
                    }
                    if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'SYNTHETIC_LONG'
                    }
                    // else {
                    //     //throw an error
                    //     state.strategy = "CUSTOM"
                    // }
                  }
                } else if (state.optionLegs[0].type == 2314) {
                  if (state.optionLegs[0].strike < state.optionLegs[1].strike) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'CUSTOM'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'CUSTOM'
                    } else {
                      state.strategy = 'CUSTOM'
                    }
                  } else if (
                    state.optionLegs[0].strike > state.optionLegs[1].strike
                  ) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_GUTS_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_GUTS_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'CUSTOM'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'CUSTOM'
                    } else {
                      state.strategy = 'CUSTOM'
                    }
                  }
                } else {
                  if (state.optionLegs[1].strike < state.optionLegs[0].strike) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'CUSTOM'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'CUSTOM'
                    } else {
                      //error
                      state.strategy = 'CUSTOM'
                    }
                  } else if (
                    state.optionLegs[1].strike > state.optionLegs[0].strike
                  ) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'LONG_GUTS_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'SHORT_GUTS_STRANGLE'
                    } else if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      state.strategy = 'CUSTOM'
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      state.strategy = 'CUSTOM'
                    } else {
                      //error
                      state.strategy = 'CUSTOM'
                    }
                  }
                }
              } else {
                //error
                state.strategy = 'ERROR'
              }
            }
            // else {
            //     //TODO throw an error - make a strategy callled error and check where permissions are being checked
            //     //if error instate.optionLegsid trade type and can make a pop out that way
            //     state.strategy = "CUSTOM"
            // }
          } else if (state.optionLegs.length == 3) {
            // if (state.optionLegs[0].type == state.optionLegs[2].type && state.optionLegs[1].type != state.optionLegs[0].type) {
            //     if (state.optionLegs[0].type == 2315){

            //     }
            // }
            if (
              state.optionLegs[0].expiration ==
                state.optionLegs[1].expiration &&
              state.optionLegs[1].expiration == state.optionLegs[2].expiration
            ) {
              if (
                state.optionLegs[0].type == state.optionLegs[2].type &&
                state.optionLegs[1].type == state.optionLegs[2].type
              ) {
                if (
                  state.optionLegs[0].quantity ==
                    state.optionLegs[2].quantity &&
                  state.optionLegs[1].quantity ==
                    state.optionLegs[0].quantity * 2
                ) {
                  if (
                    state.optionLegs[0].action == state.optionLegs[2].action &&
                    state.optionLegs[2].action != state.optionLegs[1].action
                  ) {
                    if (
                      state.optionLegs[0].action == 276 &&
                      state.optionLegs[1].action == 277
                    ) {
                      if (state.optionLegs[0].type == 2315) {
                        state.strategy = 'LONG_CALL_BUTTERFLY'
                      } else {
                        state.strategy = 'LONG_PUT_BUTTERFLY'
                      }
                    } else if (
                      state.optionLegs[0].action == 277 &&
                      state.optionLegs[1].action == 276
                    ) {
                      if (state.optionLegs[0].type == 2315) {
                        state.strategy = 'SHORT_CALL_BUTTERFLY'
                      } else {
                        state.strategy = 'SHORT_PUT_BUTTERFLY'
                      }
                    }
                  } else {
                    state.strategy = 'CUSTOM'
                  }
                } else {
                  state.strategy = 'ERROR'
                }
              }
            } else {
              state.strategy = 'CUSTOM'
            }
          } else if (state.optionLegs.length == 4) {
            if (
              state.optionLegs[0].type == state.optionLegs[1].type &&
              state.optionLegs[1].type == state.optionLegs[2].type &&
              state.optionLegs[1].type == state.optionLegs[3].type
            ) {
              if (
                state.optionLegs[0].expiration ==
                  state.optionLegs[1].expiration &&
                state.optionLegs[1].expiration ==
                  state.optionLegs[2].expiration &&
                state.optionLegs[1].expiration == state.optionLegs[3].expiration
              ) {
                if (
                  state.optionLegs[0].action == state.optionLegs[3].action &&
                  state.optionLegs[1].action == state.optionLegs[2].action &&
                  state.optionLegs[2].action != state.optionLegs[0].action
                ) {
                  if (state.optionLegs[0].type == 2315) {
                    if (state.optionLegs[0].action == 276) {
                      state.strategy = 'LONG_CALL_CONDOR'
                    } else if (state.optionLegs[0].action == 277) {
                      state.strategy = 'SHORT_CALL_CONDOR'
                    }
                  } else {
                    if (state.optionLegs[0].action == 276) {
                      state.strategy = 'LONG_PUT_CONDOR'
                    } else if (state.optionLegs[0].action == 277) {
                      state.strategy = 'SHORT_PUT_CONDOR'
                    }
                  }
                } else {
                  state.strategy = 'ERROR'
                }
              } else {
                state.strategy = 'ERROR'
              }
            } else if (
              state.optionLegs[0].type &&
              state.optionLegs[1].type == 2314 &&
              state.optionLegs[2].type &&
              state.optionLegs[3].type == 2315
            ) {
              if (
                state.optionLegs[0].expiration ==
                  state.optionLegs[1].expiration &&
                state.optionLegs[2].expiration ==
                  state.optionLegs[3].expiration &&
                state.optionLegs[2].expiration == state.optionLegs[1].expiration
              ) {
                if (
                  state.optionLegs[0].action == state.optionLegs[1].action &&
                  state.optionLegs[2].action == state.optionLegs[3].action &&
                  state.optionLegs[2].action != state.optionLegs[0].action
                ) {
                  if (
                    state.optionLegs[1].strike == state.optionLegs[2].strike
                  ) {
                    if (state.optionLegs[0].action == 276) {
                      state.strategy = 'LONG_IRON_BUTTERFLY'
                    }
                    if (state.optionLegs[0].action == 277) {
                      state.strategy = 'SHORT_IRON_BUTTERFLY'
                    }
                  } else {
                    if (state.optionLegs[0].action == 276) {
                      state.strategy = 'LONG_IRON_CONDOR'
                    } else if (state.optionLegs[0].action == 277) {
                      state.strategy = 'SHORT_IRON_CONDOR'
                    } else {
                      state.strategy = 'CUSTOM'
                    }
                  }
                }
              } else {
                // var date0DD = new Date(state.optionLegs[0].expiration.replace(/-/g, '/'));//TODO for comparing dates use getTime()
                // var date1DD = new Date(state.optionLegs[1].expiration.replace(/-/g, '/'));
                if (
                  state.optionLegs[1].expiration ==
                    state.optionLegs[2].expiration &&
                  state.optionLegs[0].expiration ==
                    state.optionLegs[3].expiration &&
                  state.optionLegs[2].expiration !=
                    state.optionLegs[1].expiration
                ) {
                  // if (state.optionLegs[0].type && state.optionLegs[1].type == 2314 && state.optionLegs[2].type && state.optionLegs[3].type == 2315) {
                  if (
                    state.optionLegs[1].action == state.optionLegs[2].action &&
                    state.optionLegs[0].action == state.optionLegs[3].action &&
                    state.optionLegs[2].action != state.optionLegs[0].action
                  ) {
                    if (state.optionLegs[0].action == 276) {
                      state.strategy = 'LONG_DOUBLE_DIAGONAL'
                    }
                    if (state.optionLegs[0].action == 277) {
                      state.strategy = 'SHORT_DOUBLE_DIAGONAL'
                    }
                  }
                  // }
                }
                // else if (state.optionLegs[1].expiration == state.optionLegs[2].expiration && state.optionLegs[0].expiration == state.optionLegs[3].expiration && state.optionLegs[2].expiration != state.optionLegs[1].expiration && date1DD > date0DD) {
                //     if (state.optionLegs[0].type && state.optionLegs[1].type == 2314 && state.optionLegs[2].type && state.optionLegs[3].type == 2315) {
                //         if (state.optionLegs[1].action == state.optionLegs[2].action && state.optionLegs[0].action == state.optionLegs[3].action && state.optionLegs[2].action != state.optionLegs[0].action) {
                //             if (state.optionLegs[0].action == 276) {
                //                 state.strategy = "SHORT_DOUBLE_DIAGONAL"
                //             }
                //             if (state.optionLegs[0].action == 277) {
                //                 state.strategy = "LONG_DOUBLE_DIAGONAL"
                //             }
                //         }
                //     }
                // }
                // else {
                //     state.strategy = "ERROR"
                // }
              }
            }
          }
        } else {
          state.strategy = null
        }
      } else {
        //TODO need to incoorporate positons into this
        // cash secured put
        if (state.optionLegs.length == 1) {
          if (state.optionLegs[0].type == 2314) {
            if (
              state.optionLegs[0].action == 276 &&
              state.equityLeg[0].action == 279
            ) {
              state.strategy = 'MARRIED_PUT'
            } else if (
              state.optionLegs[0].action == 277 &&
              state.equityLeg[0].action == 281
            ) {
              state.strategy = 'COVERED_PUT'
            }
            //equity leg 1 option leg married put
          } else if (state.optionLegs[0].type == 2315) {
            if (
              state.optionLegs[0].action == 276 &&
              state.equityLeg[0].action == 281
            ) {
              state.strategy = 'MARRIED_CALL'
            } else if (
              state.optionLegs[0].action == 277 &&
              state.equityLeg[0].action == 279
            ) {
              state.strategy = 'COVERED_CALL'
            }
          } else {
            state.strategy = 'CUSTOM'
          }
        }
        if (state.optionLegs.length == 2) {
          if (
            state.optionLegs[0].type == 2314 &&
            state.optionLegs[1].type == 2315
          ) {
            if (
              state.optionLegs[0].action == 276 &&
              state.optionLegs[1].action == 277
            ) {
              if (state.equityLeg[0].action == 279) {
                state.strategy = 'COLLAR'
              }
            }
          } else {
            state.strategy = 'CUSTOM'
          }
        }
      }
    },
    resetStrategy(state) {
      state.strategy = null
    },
  },

  actions: {},
}
